import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      title: 'CEO, TechFlow Solutions',
      location: 'Toronto, Canada',
      image: 'https://images.unsplash.com/photo-1650784855038-9f4d5ed154a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwZGl2ZXJzZXxlbnwwfHx8fDE3NzExMzg1NDZ8MA&ixlib=rb-4.1.0&q=85',
      quote: "GrowthPop transformed our LinkedIn presence completely. Within 3 months, we generated over 150 qualified leads and closed 8 major deals. The ROI has been exceptional.",
      results: '150+ leads, 340% ROI increase'
    },
    {
      name: 'James Rodriguez',
      title: 'Founder, Global Ventures',
      location: 'Miami, USA',
      image: 'https://images.unsplash.com/photo-1659353221237-6a1cfb73fd90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwZGl2ZXJzZXxlbnwwfHx8fDE3NzExMzg1NDZ8MA&ixlib=rb-4.1.0&q=85',
      quote: 'The content strategy they developed positioned me as a thought leader in my industry. My network grew by 500% with high-quality connections that converted to clients.',
      results: '500% network growth'
    },
    {
      name: 'Fatima Al-Rashid',
      title: 'Managing Director, Dubai Innovations',
      location: 'Dubai, UAE',
      image: 'https://images.pexels.com/photos/33871730/pexels-photo-33871730.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      quote: 'Working with GrowthPop has been transformative for our business. Their strategic approach to LinkedIn marketing helped us break into new markets across the Middle East.',
      results: 'Expanded to 3 new markets'
    },
    {
      name: 'David Chen',
      title: 'Director, Melbourne Marketing Group',
      location: 'Melbourne, Australia',
      image: 'https://images.unsplash.com/photo-1659353221237-6a1cfb73fd90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwZGl2ZXJzZXxlbnwwfHx8fDE3NzExMzg1NDZ8MA&ixlib=rb-4.1.0&q=85',
      quote: 'The lead generation campaigns delivered consistent results month after month. GrowthPop understands the nuances of B2B marketing and knows how to drive real business outcomes.',
      results: 'Consistent monthly growth'
    },
    {
      name: 'Emma Thompson',
      title: 'VP of Sales, London FinTech',
      location: 'London, UK',
      image: 'https://images.unsplash.com/photo-1650784855038-9f4d5ed154a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwZGl2ZXJzZXxlbnwwfHx8fDE3NzExMzg1NDZ8MA&ixlib=rb-4.1.0&q=85',
      quote: 'Professional, strategic, and results-driven. GrowthPop helped us reach C-level executives at Fortune 500 companies. The quality of leads improved dramatically.',
      results: 'Reached Fortune 500 clients'
    },
    {
      name: 'Michael Anderson',
      title: 'Co-Founder, Seattle Tech Hub',
      location: 'Seattle, USA',
      image: 'https://images.unsplash.com/photo-1659353221237-6a1cfb73fd90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBvcnRyYWl0JTIwZGl2ZXJzZXxlbnwwfHx8fDE3NzExMzg1NDZ8MA&ixlib=rb-4.1.0&q=85',
      quote: "GrowthPop doesn't just manage LinkedIn; they build a complete brand presence. Our engagement rates increased by 400%, and we're now recognized as industry leaders.",
      results: '400% engagement increase'
    }
  ];

  return (
    <div className="pt-16">
      <section className="py-32 bg-primary-dark text-text-inverse" data-testid="testimonials-hero">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="inline-block text-secondary-main font-body uppercase tracking-widest text-xs mb-4"
            data-testid="testimonials-subtitle"
          >
            Client Success Stories
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="font-heading text-4xl lg:text-6xl font-bold mb-6 leading-tight"
            data-testid="testimonials-title"
          >
            Trusted by SMBs <span className="italic text-secondary-main">Worldwide</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-text-inverse/80 text-lg max-w-3xl mx-auto leading-relaxed"
            data-testid="testimonials-description"
          >
            From startups to established enterprises, our clients worldwide trust us to deliver measurable LinkedIn marketing results.
          </motion.p>
        </div>
      </section>

      <section className="py-20 bg-background-main" data-testid="testimonials-grid">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white border border-primary-main/10 p-8 hover:shadow-xl transition-all relative"
                data-testid={`testimonial-card-${index}`}
              >
                <Quote className="w-10 h-10 text-secondary-main/30 absolute top-4 right-4" />
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-secondary-main text-secondary-main" data-testid={`star-${index}-${i}`} />
                  ))}
                </div>
                <p className="text-text-secondary leading-relaxed mb-6 italic" data-testid={`testimonial-quote-${index}`}>
                  "{testimonial.quote}"
                </p>
                <div className="border-t border-primary-main/10 pt-6 flex items-center gap-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover"
                    data-testid={`testimonial-image-${index}`}
                  />
                  <div>
                    <h4 className="font-body font-semibold text-primary-main" data-testid={`testimonial-name-${index}`}>{testimonial.name}</h4>
                    <p className="text-sm text-text-secondary" data-testid={`testimonial-title-${index}`}>{testimonial.title}</p>
                    <p className="text-xs text-text-muted" data-testid={`testimonial-location-${index}`}>{testimonial.location}</p>
                  </div>
                </div>
                <div className="mt-4 pt-4 border-t border-primary-main/10">
                  <p className="text-xs uppercase tracking-widest text-secondary-main font-semibold" data-testid={`testimonial-results-${index}`}>
                    {testimonial.results}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-32 bg-white" data-testid="testimonials-cta">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-heading text-4xl lg:text-5xl font-bold text-primary-main mb-6" data-testid="cta-heading">
            Join Our Success Stories
          </h2>
          <p className="text-text-secondary text-lg leading-relaxed mb-8" data-testid="cta-description">
            Start your journey to LinkedIn marketing excellence today.
          </p>
          <a
            href="/enquiry"
            data-testid="cta-button"
            className="bg-primary-main text-white hover:bg-primary-light rounded-none px-8 py-4 uppercase tracking-widest text-xs font-semibold inline-block transition-all"
          >
            Get Started Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;